import { Text } from "@chakra-ui/react";

export const SalesCannotValidateInvoiceEMECeFError = () => {
  return (
    <Text>
      La validation de la vente sur la plateforme e-MECeF a généré une erreur
    </Text>
  );
};
